import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import FloorObjectGlyph from './FloorObjectGlyph';
import {
  DialogHeader,
  FP,
  fpDialogActionsSx,
  fpDialogPaperProps,
} from './lib/ui';

const AddObjectModal = ({ open, onClose, presets = [], onAdd }) => {
  const [selected, setSelected] = useState(presets[0]?.kind || 'door');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={fpDialogPaperProps}
    >
      <DialogHeader
        title="Add object"
        subtitle="Add doors, walls and fixtures to orient your floor."
        onClose={onClose}
      />
      <DialogContent sx={{ px: 3 }}>
        <Box
          sx={{
            pt: 1,
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(96px, 1fr))',
            gap: 1.25,
          }}
        >
          {presets.map((preset) => {
            const active = selected === preset.kind;
            return (
              <Box
                key={preset.kind}
                role="button"
                tabIndex={0}
                onClick={() => setSelected(preset.kind)}
                onKeyDown={(e) => e.key === 'Enter' && setSelected(preset.kind)}
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 0.5,
                  height: 100,
                  cursor: 'pointer',
                  borderRadius: 2.5,
                  p: 1,
                  border: active
                    ? `2px solid ${FP.primary}`
                    : `1px solid ${FP.line}`,
                  bgcolor: active ? FP.primarySoft : '#fff',
                  transition: 'all 0.15s ease',
                  '&:hover': {
                    borderColor: active ? FP.primary : FP.faint,
                    bgcolor: active ? FP.primarySoft : FP.surface,
                  },
                }}
              >
                <Box sx={{ width: 44, height: 44 }}>
                  <FloorObjectGlyph
                    object={preset}
                    selected={active}
                    showLabel={false}
                  />
                </Box>
                <Typography
                  sx={{
                    fontSize: 12,
                    fontWeight: 700,
                    color: active ? FP.primaryDark : FP.sub,
                    textTransform: 'capitalize',
                  }}
                >
                  {preset.label || preset.kind}
                </Typography>
              </Box>
            );
          })}
        </Box>
      </DialogContent>
      <DialogActions sx={fpDialogActionsSx}>
        <Button onClick={onClose} sx={{ textTransform: 'none' }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            const preset =
              presets.find((p) => p.kind === selected) || presets[0];
            if (preset) {
              onAdd(preset);
            }
            onClose();
          }}
          sx={{
            textTransform: 'none',
            fontWeight: 700,
            px: 2.5,
            bgcolor: FP.primary,
            '&:hover': { bgcolor: FP.primaryDark },
          }}
        >
          Add object
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddObjectModal;
